module.exports = __webpack_public_path__ + "static/media/g-3-c.3c286191.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gadgets/g-3-c.jpg
// module id = 1134
// module chunks = 33